import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router';

export const DEFAULT_ROUTE = '/assets';
export const routes = [DEFAULT_ROUTE];

const DefaultRedirect = () => {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if (!routes.includes(pathname)) {
            navigate(DEFAULT_ROUTE);
        }
    }, [navigate, pathname]);

    return null;
};

export default DefaultRedirect;
